import { render, staticRenderFns } from "./new-vehicle-form.vue?vue&type=template&id=97f20646&"
import script from "./new-vehicle-form.vue?vue&type=script&lang=js&"
export * from "./new-vehicle-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports